import React from 'react';
import ReactDOM from 'react-dom';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import PicSlide from './picSlide';
import PicOver from './picover';
import PicMask from './picMask';
import ShareBox from './shareBox';
import Caption from './caption';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';
import { addEventListener, debounce, Event } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from 'ThreeTerminal_pc_dynamic';
import { requestTongji } from '../../../../services/api';

const getWindowWidth = () => {
    if (window.innerWidth !== undefined) {
        return window.innerWidth;
    } else {
        const B = document.body;
        const D = document.documentElement;

        return Math.min(D.clientWidth, B.clientWidth);
    }
};

const getHeight = () => {
    if (window.innerHeight !== undefined) {
        return window.innerHeight;
    } else {
        const B = document.body;
        const D = document.documentElement;

        return Math.min(D.clientHeight, B.clientHeight);
        // return Math.min(947, 947);
    }
};

class Content extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        slideData: PropTypes.array,
        content: PropTypes.object,
    };

    state = {
        // 当前幻灯
        current: 0,
        // 幻灯图片总数
        total: this.props.slideData ? this.props.slideData.length : 0,
        // 改变幻灯视图
        changeView: 'normal',
        // 播放器播放暂停状态
        videoPlay: false,
        // 自适应高度
        picCurrentH: 0,
        picContainerH: 0,
        maskH: 0,
        sH: 0,
    };

    event = new Event();

    async componentDidMount() {
        this.unhandleKeyDown = addEventListener(window, 'keydown', this.handleKeyDown);
        this.unresizePic = addEventListener(window, 'resize', this.debounceFn);
        this.unhashchange = addEventListener(window, 'hashchange', this.changePage);

        try {
            this.changePage();
            this.resizePic();
        } catch (e) {
            console.error(e);

            if (window && window.BJ_REPORT) window.BJ_REPORT.report(e, false, 'ui');
        }
    }

    componentWillUnmount() {
        this.unhandleKeyDown();
        this.unresizePic();
        this.unhashchange();
    }

    // 页面刷新，hash改变刷新
    changePage = () => {
        const { current, total, changeView } = this.state;
        const href = window.location.href;
        const hrefArr = href.split('#');

        if (hrefArr[1] && hrefArr[1].includes('=')) {
            let page = parseInt(hrefArr[1].split('=')[1]);

            if (isNaN(page)) {
                page = 1;
                window.location.hash = '#p=1';
            }

            if (current + 1 === page) {
                return;
            }

            if (page <= total) {
                if (changeView === 'isOver') {
                    // 最后一帧推广翻页处理
                    this.setState({ current: page - 1, changeView: 'normal' });
                } else {
                    // 页码范围内翻页处理
                    this.setState({ current: page - 1, changeView, videoPlay: false });
                }
            } else if (page >= total + 1) {
                // 最后一帧推广 url不带&自动补全
                window.location.hash = `#p=${total + 1}&_cpb_slide_last`;
                this.setState({ current: total - 1, changeView: 'isOver' });
            } else if (`${page}`.indexOf('&') !== -1) {
                // 最后一帧推广 url中带&
                this.setState({ current: total - 1, changeView: 'isOver' });
            } else {
                // 页码大于总页数+1时
                this.setState({ current: total - 1, changeView });
            }
        } else {
            // 没有指定页码时，默认为p=1
            window.location.hash = '#p=1';
        }
        // 每一个图片尺寸不一样
        this.resizePic();
    };

    // 监听屏幕尺寸变化,窗口大小改变，图片高度自适应
    resizePic = () => {
        const { current } = this.state;
        const { slideData } = this.props;
        // ie8不支持获取窗口大小
        // const sW = getWindowWidth();
        const sH = getHeight();
        const bH = 735;
        const bW = 1198; // 大图预览幻灯宽度

        // console.log('sH__', sH);
        // const isIE8 = !!window.ActiveXObject && !!document.documentMode;

        const picH = current < this.state.total ? slideData[current].height : '';
        const picW = current < this.state.total ? slideData[current].width : '';

        if (sH > 528 && sH < 845) {
            const h = sH - 45 - 97 - 19 - 80; // 普通幻灯盒子高度
            const w = 870; // 普通幻灯盒子宽度

            // 判断图片比例, 决定缩放高度还是宽度
            if (picH / picW > h / w && picH > h) {
                // 高度优先，图片高度大于盒子高度，缩放
                this.setState({ picCurrentH: h, picContainerH: h });
            } else if (picH / picW > h / w && picH <= h) {
                // 高度优先，图片高度小于盒子高度，图片在里边
                this.setState({ picCurrentH: 'auto', picContainerH: h });
            } else if (picW > w) {
                // 宽度优先，图片宽度大于盒子宽度，缩放
                this.setState({ picCurrentH: (w * picH) / picW, picContainerH: h });
            } else {
                // 宽度优先，图片宽度小于盒子宽度，图片在里边
                this.setState({ picCurrentH: 'auto', picContainerH: h });
            }

            // if (picH >= h) {
            //     // 判断870*比例得到的高度<h
            //     if (h > (870 * picH) / picW) {
            //         this.setState({ picCurrentH: (870 * picH) / picW, picContainerH: h });
            //     } else {
            //         this.setState({ picCurrentH: h, picContainerH: h });
            //     }
            // } else if (isIE8 === true) {
            //     this.setState({ picCurrentH: picH, picContainerH: h });
            // } else {
            //     this.setState({ picCurrentH: 'auto', picContainerH: h });
            // }
            // if (sH > (1198 * picH) / picW) {
            //     this.setState({ maskH: (1198 * picH) / picW, sH });
            // } else {
            //     this.setState({ maskH: sH, sH });
            // }
        } else if (sH < 529) {
            this.setState({ picCurrentH: 'auto', picContainerH: 786 - 45 - 97 - 19 - 80 });
        } else {
            this.setState({ picCurrentH: 'auto', picContainerH: 600 });
        }

        if (picH / picW > bH / bW && picH > bH) {
            // 高度优先，图片高度大于盒子高度，缩放
            this.setState({ maskH: bH, sH });
        } else if (picH / picW > bH / bW && picH <= bH) {
            // 高度优先，图片高度小于盒子高度，图片在里边
            this.setState({ maskH: 'auto', sH });
        } else if (picW > bW) {
            // 宽度优先，图片宽度大于盒子宽度，缩放
            this.setState({ maskH: (bW * picH) / picW, sH });
        } else {
            // 宽度优先，图片宽度小于盒子宽度，图片在里边
            this.setState({ maskH: 'auto', sH });
        }
    };
    debounceFn = debounce(this.resizePic, 100);

    // 上一页
    handlePicPrev = () => {
        const { current } = this.state;

        if (current > 0) {
            this.setState(
                {
                    current: current - 1,
                },
                () => {
                    window.location.hash = `#p=${current}`;
                    // 翻页发送统计
                    window.analytics(encodeURIComponent(window.location.href));
                },
            );
        }
    };

    // 下一页
    handlePicNext = () => {
        const { current, total } = this.state;

        if (current < total - 1) {
            this.setState(
                {
                    current: current + 1,
                },
                () => {
                    window.location.hash = `#p=${current + 2}`;
                    window.analytics(encodeURIComponent(window.location.href));
                },
            );
        } else {
            this.setState(
                {
                    current: total - 1,
                    changeView: 'isOver',
                },
                () => {
                    window.location.hash = `#p=${total + 1}&_cpb_slide_last`;
                    window.analytics(encodeURIComponent(window.location.href));
                },
            );
        }
    };

    // 打开全屏
    handleBigOpen = () => {
        this.setState({ changeView: 'isBig' });
        // 打开全屏发送统计
        requestTongji('pic', 'f_scr');
    };

    // 关闭全屏
    handleBigClose = () => {
        this.setState({ changeView: 'normal', videoPlay: false });
        // 关闭全屏发送统计
        requestTongji('pic', 'c_scr');
    };

    // 最后一帧，上一页
    handleOverPrev = () => {
        this.setState({ changeView: 'normal', videoPlay: false }, () => {
            window.location.hash = `#p=${this.state.current + 1}`;
            window.analytics(encodeURIComponent(window.location.href));
        });
    };

    // 最后一页，下一图集
    handleOverNext = () => {
        const { preSlide, url, id } = this.props.docData;
        let nextUrl = '';
        let nextId = '';

        if (preSlide && preSlide.url) {
            nextUrl = preSlide.url;
            nextId = preSlide.id;
        } else {
            nextUrl = url;
            nextId = id;
        }

        window.location.href = `${nextUrl}?_cpb_slide_next&_cpb_slide_next_2`;
        window.analytics(encodeURIComponent(window.location.href));
    };

    // 区域范围内点击翻页
    // handleAreaClick = e => {
    //     let l = (document.body.clientWidth * 1) / 3;
    //     let r = (document.body.clientWidth * 2) / 3;

    //     if (e.pageX < l) {
    //         this.handlePicPrev();
    //     }
    //     if (e.pageX > r) {
    //         this.handlePicNext();
    //     }
    // };
    // 键盘左右方向键切换和全屏退出功能
    handleKeyDown = e => {
        if (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 27) {
            e.preventDefault();
        }
        const { current, total, changeView } = this.state;

        if (e.keyCode === 37) {
            if (changeView === 'isOver') {
                this.handleOverPrev();
            } else {
                this.handlePicPrev(current);
            }
        } else if (e.keyCode === 39) {
            if (changeView === 'isOver') {
                // 下一个图集
                this.handleOverNext();
            } else {
                this.handlePicNext(current, total);
            }
        } else if (e.keyCode === 27) {
            this.handleBigClose();
        } else {
            return;
        }
    };

    // 视频播放
    handleVideoPlay = () => {
        this.setState({ videoPlay: true });
    };
    /**
     * 渲染网页布局
     */
    render() {
        const { changeView, current, videoPlay, picCurrentH, picContainerH, maskH, sH, total } = this.state;
        const {
            content: { chipObj, bottomAd, rightAd, recommend, lastAd, interact, hasCopyRight, sourceReason },
            docData,
            docData: { noAd, commentUrl, title, url, editorName, editorCode, channel, skey },
            slideData,
        } = this.props;
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        const commentConfig = {
            noAd,
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl: url,
            // 获取评论内容接口
            cmtNumUrl: `//${ commentDomain }/get.php`,
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: `//${ commentDomain }/post.php`,
            // 最热评论数量
            hotLimit: 3,
            // 评论区域的高度限制
            limitHeight: '310px',
            // 推荐评论接口
            cmtVoteUrl: `//${ commentDomain }/vote.php`,
            // 现实回复的楼层
            replyLimit: 5,
            // 举报提交接口
            jubUrl: `//${ commentDomain }/report`,
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
        };

        const picMaskData = {
            slideData,
            videoPlay,
            current,
            maskH,
            sH,
            total,
        };

        const picOverData = {
            chipObj,
            recommend,
        };

        const picSlideData = {
            slideData,
            total,
            videoPlay,
            current,
            picCurrentH,
            picContainerH,
        };

        const Slide = state => {
            switch (state) {
                case 'isBig':
                    return (
                        <PicMask
                            picMaskData={picMaskData}
                            handlePicPrev={this.handlePicPrev}
                            handlePicNext={this.handlePicNext}
                            handleBigClose={this.handleBigClose}
                            handleVideoPlay={this.handleVideoPlay}
                            resizePic={this.debounceFn}
                        />
                    );
                case 'isOver':
                    return (
                        <PicOver
                            picOverData={picOverData}
                            handleOverPrev={this.handleOverPrev}
                            handleOverNext={this.handleOverNext}
                            lastAd={lastAd}
                        />
                    );
                default:
                    return (
                        <PicSlide
                            picSlideData={picSlideData}
                            handlePicPrev={this.handlePicPrev}
                            handlePicNext={this.handlePicNext}
                            handleBigOpen={this.handleBigOpen}
                            handleVideoPlay={this.handleVideoPlay}
                        />
                    );
            }
        };
        const isShowEditName = editorCode && (hasCopyRight || sourceReason === '公开信息');

        return (
            <div onKeyDown={this.handleKeyDown}>
                <div className={styles.hdpTit}>
                    <Caption docData={docData} changeView={changeView} />
                    <ShareBox docData={docData} interact={interact} />
                </div>
                {Slide(changeView)}
                <div className={changeView === 'isOver' ? styles.showOff : ''}>
                    <div className={styles.comment_box}>
                        <div className={styles.commentL}>
                            <LazyLoad>
                                <Comment articleInfo={commentConfig} />
                            </LazyLoad>
                        </div>
                        <NoSSR>
                            <Chip
                                id={chipObj.rightAd}
                                type="static"
                                title="右侧广告"
                                groupName="右侧"
                                translate="handleAreaAd"
                                content={rightAd}>
                                <AreaStaticChip styleName={rightAd ? styles.right_box : styles.right_ebox} />
                            </Chip>
                        </NoSSR>
                    </div>
                    <NoSSR>
                        <Chip
                            id={chipObj.bottomAd}
                            type="static"
                            title="底部广告"
                            groupName="底部"
                            translate="handleAreaAd"
                            content={bottomAd}>
                            <AreaStaticChip styleName={bottomAd ? styles.bottom_box : styles.bottom_ebox} />
                        </Chip>
                    </NoSSR>
                    {isShowEditName ? (
                        <div className={styles.zrb}>{editorName ? `[责任编辑：${editorName}]` : ''}</div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
